import _ from 'lodash';
import { getContact } from '../../graphql/queries';
import api from '../../services/api';
import debug from '../../services/debug';
import {
  SET_CONTACT_REQUESTED,
  SET_CONTACT_ABORTED,
  SET_CONTACT_COMPLETED,
  SET_CONTACT_FAILED,
} from './types';

const setContactAction = () => async (dispatch, getState) => {
  const { contacts } = getState();

  const contact = contacts.get('set');
  if (!_.isEmpty(contact) && contact.ContactID !== 0) {
    dispatch({
      type: SET_CONTACT_ABORTED,
    });

    return;
  }

  dispatch({
    type: SET_CONTACT_REQUESTED,
  });

  try {
    const { data } = await api.graphql({
      query: getContact,
    });

    dispatch({
      type: SET_CONTACT_COMPLETED,
      payload: data.getContact,
    });
  } catch (err) {
    debug(SET_CONTACT_FAILED, err);

    dispatch({
      type: SET_CONTACT_FAILED,
      payload: err,
    });
  }
};

export default setContactAction;
